import React from 'react'
import { useContext } from './Context'
import { TaskInput } from '../../TaskInput'

export const ListFooter = () => {
  const { setNewTasks, newTasks } = useContext()
  const [newTask, setNewTask] = React.useState('')

  return (
    <tfoot>
      <tr>
        <td className="m-0 p-0" colSpan={2}>
          <TaskInput
            onAdd={async (name) => {
              setNewTasks([...newTasks, { name }])
              setNewTask('')
            }}
            value={newTask}
          />
        </td>
      </tr>
    </tfoot>
  )
}
